import React from 'react';
import QuestionDependency from '../QuestionDependency';
import HtmlComponent from '../../lessonPlayer/components/HtmlComponent';

const WebPage = ({ model, isManuscriptShort }) => {
  return (
    <>
      <div className='top-label'>Instruction:</div>
      <div className='element-container' id={`_${model.id}`}>
        <div className='label-value-row'>
          <div>Instruction Type:</div>
          <div>Web Page</div>
        </div>
        <div className='label-value-row'>
          <div>Text:</div>
          <div className='ckeditor-text'><HtmlComponent htmlStr={model.text} /></div>
        </div>
        <div className='label-value-row'>
          <div>URL:</div>
          <div>{model.url}</div>
        </div>
        <div className='label-value-row'>
          <div>Display:</div>
          <div>{model.display}</div>
        </div>
        <iframe src={model.url} title={model.id} />
        {/* advanced options */}
        {!isManuscriptShort && (
          <>
            <QuestionDependency model={model} />
            <div className='label-value-row'>
              <div>Extra Class:</div>
              <div>{model.extraClass}</div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default WebPage;
